import React from "react"

import styles from "./ButtonGroup.module.scss"

const ButtonGroup = ({
  wide,
  oneLine,
  threeLines,
  mobileMarginLeft,
  smallGutters,
  tabs,
  children,
}) => {
  return (
    <section
      className={`${styles.group} ${smallGutters ? styles.smallGutters : ""} ${
        tabs ? styles.tabs : ""
      } ${
        oneLine || threeLines
          ? `make-full-width-on-mobile make-full-width-on-mobile-with-paddings`
          : ""
      } ${oneLine && !threeLines ? styles.isOneLine : ""} ${
        threeLines ? styles.isThreeLines : ""
      } ${wide ? styles.isWide : ""} ${
        mobileMarginLeft ? styles.mobileMarginLeft : ""
      }`}
    >
      {threeLines && <div>{children}</div>}
      {!threeLines && <>{children}</>}
    </section>
  )
}

export default ButtonGroup
